/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-05-27 11:19
 * @LastEditors: 1544807500@qq.com
 * @LastEditTime: 2025-06-20 10:52
 * @FilePath: \glyun_web_Vue3\src\const\index.js
 * @Description: xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
 */
import global from './global'
import routeMap from './routeMap'
// console.log("🚀 ~ global:", global)
export default {
  ...global,
  ...routeMap,
}